// extracted by mini-css-extract-plugin
module.exports = {"sidebarAd":"news_sidebarAd__xML_k","socialShare":"news_socialShare__FJ6dv","socialShare__group":"news_socialShare__group__ZaVQG"};